import { Box, Divider, IconButton, Modal, styled, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { FormCreateOrEditFlightIntegration } from '../FormCreateOrEditFlightIntegration';

interface Props {
  open: boolean;
  onClose: () => void;
}

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  background: theme.palette.background.paper,
  'box-shadow': 24,
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
}));

export const CreateFlightIntegrationModal = ({ open, onClose }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} aria-labelledby={t('flightIntegrations.create.title')}>
      <StyledBox display="flex" flexDirection="column" gap={theme.spacing(2)}>
        <Box display="flex" gap={theme.spacing(2)}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={theme.spacing(1)}>
            <Typography id="create-flight-integrations-modal-title" variant="h6" component="h2">
              {t('flightIntegrations.create.title')}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        <FormCreateOrEditFlightIntegration onClose={onClose} />
      </StyledBox>
    </Modal>
  );
};
